(() => {
  'use strict';

  const STORAGE_KEY = 'anniversary-lottery-15th-progress';

  const STORY_API = {
    baseUrl: 'https://global.shokz.com',
    xSite: 'de',
    apiKey: 'ZI942AA573A205BRX4D1FD3230A09A6',
    uploadDir: 'brandMonth',
  };

  const LOTTERY_MSG = {
    no_login: 'Bitte registrieren Sie sich vor der Teilnahme mit einer gültigen E-Mail-Adresse.',
    no_finish: 'Du hast bereits an dieser Verlosung teilgenommen.',
    no_finish_ip: 'Die maximale Teilnehmerzahl ist erreicht. Bitte versuchen Sie es später erneut.',
    no_act: 'Diese Kampagne ist nicht verfügbar.',
    sign_invalid: 'Es ist ein Fehler aufgetreten. Klicken Sie auf das Zahnrad, um es erneut zu versuchen.',
    gift_map_failed: 'Es ist ein Fehler aufgetreten. Klicken Sie auf das Zahnrad, um es erneut zu versuchen.',
    error: 'Es ist ein Fehler aufgetreten. Klicken Sie auf das Zahnrad, um es erneut zu versuchen.',
  };

  const MSG_SUBMIT_FAILED = 'Absenden fehlgeschlagen, bitte versuchen Sie es erneut.';

  const initAnniversaryLottery = (root) => {
    if (!root) return;
    const stepItems = root.querySelectorAll('.anniversary-lottery-step-item');
    const subscribeItem = root.querySelector('[data-step-type="subscribe"]');
    const shareItem = root.querySelector('[data-step-type="share"]');
    const shareBtn = shareItem ? shareItem.querySelector('.anniversary-lottery-share') : null;
    const memoryBtn = root.querySelector('[data-memory-cta]');
    const lotteryCard = root.querySelector('.anniversary-lottery-card');
    const wheel = root.querySelector('.anniversary-lottery-card-bg-1');
    const subscribeForm = subscribeItem
      ? subscribeItem.querySelector('.anniversary-lottery-subscribe-form')
      : null;
    const subscribeTitle = subscribeItem
      ? subscribeItem.querySelector('[data-subscribe-title]')
      : null;
    const subscribeDesc = subscribeItem
      ? subscribeItem.querySelector('[data-subscribe-desc]')
      : null;

    const shareModal = document.getElementById('PopupModal-anniversary-share');
    const resultModal = document.getElementById('PopupModal-anniversary-result');
    const memoryModal = document.getElementById('PopupModal-anniversary-memory');
    const termsModal = document.getElementById('PopupModal-anniversary-terms');
    const shareForm = shareModal ? shareModal.querySelector('[data-share-form]') : null;
    const shareFormError = shareModal ? shareModal.querySelector('[data-share-form-error]') : null;
    const formFields = shareForm ? Array.from(shareForm.querySelectorAll('[data-form-field]')) : [];
    const pendingPhotos = {};
    const pendingPhotoFiles = {};

    const giftsNode = document.querySelector('[data-anniversary-lottery-gifts]');
    let gifts = [];
    try {
      gifts = giftsNode ? JSON.parse(giftsNode.textContent || '[]') : [];
    } catch (err) {
      gifts = [];
    }

    const formMount = root.querySelector('[class*="klaviyo-form-"]');
    const formClass = formMount
      ? Array.from(formMount.classList).find((name) => name.indexOf('klaviyo-form-') === 0)
      : '';
    const formId = formClass ? formClass.replace('klaviyo-form-', '') : '';

    let isSpinning = false;
    let memoryBlobPromise = null;
    let memoryBlobResolved = null;
    let memoryBlobKey = '';

    const API_CONFIG = STORY_API;

    const shareFormMessages = shareForm
      ? {
          shareFormAgreeError: shareForm.dataset.msgAgreeError || '',
          shareFormPhotoError: shareForm.dataset.msgPhotoError || '',
          submitFailed: MSG_SUBMIT_FAILED,
        }
      : { submitFailed: MSG_SUBMIT_FAILED };

    const lotteryActIdRaw = (root.dataset.lotteryActId || '').trim();
    const lotterySign = (root.dataset.lotterySign || '').trim();
    const lotteryActId = lotteryActIdRaw ? Number(lotteryActIdRaw) : NaN;

    const LOTTERY_CONFIG = {
      tokenUrl: 'https://global.shokz.com/lottery/start',
      apiUrl: 'https://global.shokz.com/lottery/openapi_v3',
      actId: lotteryActId,
      sign: lotterySign,
      usageScenarios: 'cs',
    };
    const lotteryApiEnabled = !window.Shopify?.designMode;

    const pickField = (source, ...keys) => {
      if (!source || typeof source !== 'object') return undefined;
      for (const key of keys) {
        if (source[key] !== undefined && source[key] !== null && source[key] !== '') {
          return source[key];
        }
      }
      return undefined;
    };

    const postLotteryJson = (url, body) =>
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).then(async (res) => {
        let payload = null;
        try {
          payload = await res.json();
        } catch (err) {
          payload = null;
        }
        if (!res.ok) {
          const requestError = new Error('lottery-http-' + res.status);
          requestError.payload = payload;
          throw requestError;
        }
        return payload;
      });

    const requestLotteryDraw = async (mbId) => {
      const activityId = LOTTERY_CONFIG.actId;
      const tokenPayload = await postLotteryJson(LOTTERY_CONFIG.tokenUrl, {
        actId: activityId,
        sign: LOTTERY_CONFIG.sign,
      });
      const tokenCode = tokenPayload?.code;
      const token = pickField(tokenPayload?.data, 'token');
      if ((tokenCode !== 200 && tokenCode !== '200') || !token) {
        const tokenError = new Error('lottery-token-failed');
        tokenError.payload = tokenPayload;
        throw tokenError;
      }

      return postLotteryJson(LOTTERY_CONFIG.apiUrl, {
        mbId,
        actId: activityId,
        usageScenarios: LOTTERY_CONFIG.usageScenarios,
        sign: LOTTERY_CONFIG.sign,
        token,
      });
    };

    const lotteryAwardId = (value) => {
      if (value === undefined || value === null) return '';
      return String(value).trim();
    };

    const normalizePriceName = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

    const giftByPriceId = (apiPriceId) => {
      const id = lotteryAwardId(apiPriceId);
      if (!id) return null;
      const matched = gifts.find((gift) => lotteryAwardId(gift.priceId) === id);
      return matched ? Object.assign({}, matched) : null;
    };

    const giftByPriceName = (apiPriceName) => {
      const normalizedApi = normalizePriceName(apiPriceName);
      if (!normalizedApi) return null;
      const matched = gifts.find((gift) => {
        const configured = normalizePriceName(gift.matchPriceName);
        return configured && configured === normalizedApi;
      });
      return matched ? Object.assign({}, matched) : null;
    };

    /** API priceId → block price_id；否则 API priceName → match_price_name */
    const giftFromApiResult = (priceId, isEntity, priceName) => {
      const byPriceId = giftByPriceId(priceId);
      if (byPriceId) return byPriceId;

      const byName = giftByPriceName(priceName);
      if (byName) return byName;

      const entity = isEntity != null && isEntity !== '' ? Number(isEntity) : NaN;
      if (entity === 0) {
        const loseGift = gifts.find((gift) => gift.isWin === false);
        if (loseGift) return Object.assign({}, loseGift);
      }

      return null;
    };

    const resolveGiftFromLotteryPayload = (payload) => {
      const data = payload?.data || {};
      const outerCode = payload?.code;
      const status = pickField(data, 'status');
      const actStatus = pickField(data, 'act_status', 'actStatus');
      const priceId = pickField(data, 'priceId', 'price_id');
      const actPriceId = pickField(data, 'actPriceId', 'act_price_id');
      const priceName = pickField(data, 'priceName', 'price_name');
      const discountCode = pickField(data, 'code');
      const isEntity = pickField(data, 'isEntity', 'is_entity');

      const hasPrizeFields =
        priceId !== undefined ||
        actPriceId !== undefined ||
        (priceName != null && String(priceName).trim() !== '');

      const blockingStatus = ['no_login', 'no_finish', 'no_finish_ip', 'sign_invalid', 'no_act'];
      const actStatusStr = actStatus != null ? String(actStatus) : '';

      const entityNum = isEntity != null && isEntity !== '' ? Number(isEntity) : NaN;

      const isSuccess =
        (outerCode === 200 || outerCode === '200') &&
        !blockingStatus.includes(actStatusStr) &&
        (status === 'ok' ||
          status === 'OK' ||
          hasPrizeFields ||
          entityNum === 0);

      if (!isSuccess) {
        return { ok: false, actStatus: actStatus || status || 'error', payload };
      }

      const gift = giftFromApiResult(priceId, isEntity, priceName);
      if (!gift) {
        console.warn('[anniversary-lottery] gift map failed', {
          actPriceId,
          priceId,
          priceName,
          isEntity,
          data,
        });
        return { ok: false, actStatus: 'gift_map_failed', payload };
      }

      gift.discountCode = discountCode ? String(discountCode) : '';
      return { ok: true, gift };
    };

    const lotteryErrorMessage = (actStatus) =>
      LOTTERY_MSG[actStatus] || LOTTERY_MSG.error;

    const reportLotteryDrawFailure = (lotteryErr) => {
      const actStatus = lotteryErr && lotteryErr.actStatus ? lotteryErr.actStatus : '';
      const msg =
        lotteryErr && lotteryErr.message === 'no_login'
          ? lotteryErrorMessage('no_login')
          : lotteryErrorMessage(actStatus);
      showLotteryDrawError(msg, { isError: true });
    };

    const getLotteryDrawErrorWrap = () => {
      let wrap = root.querySelector('[data-lottery-draw-error-wrap]');
      if (wrap) return wrap;

      wrap = document.createElement('div');
      wrap.setAttribute('data-lottery-draw-error-wrap', '');
      wrap.hidden = true;

      const card = root.querySelector('.anniversary-lottery-card');
      const parent = card && card.parentElement ? card.parentElement : root;
      parent.insertBefore(wrap, card ? card.nextSibling : null);

      const el = document.createElement('p');
      el.className = 'anniversary-lottery-form-error';
      el.setAttribute('data-lottery-draw-error', '');
      el.setAttribute('role', 'alert');
      wrap.appendChild(el);

      return wrap;
    };

    const showLotteryDrawError = (message, { isError = false } = {}) => {
      const wrap = getLotteryDrawErrorWrap();
      const el = wrap.querySelector('[data-lottery-draw-error]');
      if (el) el.textContent = message;
      wrap.classList.toggle('is-lottery-draw-error', Boolean(isError && message));
      wrap.hidden = !message;
    };

    const clearLotteryDrawError = () => {
      const wrap = root.querySelector('[data-lottery-draw-error-wrap]');
      if (!wrap) return;
      wrap.classList.remove('is-lottery-draw-error');
      wrap.hidden = true;
      const el = wrap.querySelector('[data-lottery-draw-error]');
      if (el) el.textContent = '';
    };

    const showLotteryResultAgain = (opener) => {
      if (!progress.drawn || !progress.prize || !resultModal) return;
      fillResultModal(progress.prize);
      resultModal.show(opener || lotteryCard || shareBtn || memoryBtn);
    };

    const handleLotteryWheelActivate = (opener) => {
      if (isSpinning || !progress.shared) return;
      if (progress.drawn) {
        showLotteryResultAgain(opener);
        return;
      }
      attemptLotteryDraw(opener);
    };

    const attemptLotteryDraw = async (opener) => {
      if (isSpinning) return;
      if (!progress.shared || progress.drawn) return;

      clearLotteryDrawError();
      try {
        const prize = await resolveDrawPrize();
        runDrawAndSpin(opener || shareBtn || memoryBtn, prize);
      } catch (lotteryErr) {
        reportLotteryDrawFailure(lotteryErr);
      }
    };

    const resolveDrawPrize = async () => {
      if (!lotteryApiEnabled) return pickPrize();

      const email = (progress.email || '').trim();
      if (!email) {
        throw new Error('no_login');
      }
      const payload = await requestLotteryDraw(email);
      const parsed = resolveGiftFromLotteryPayload(payload);
      if (!parsed.ok) {
        const err = new Error(parsed.actStatus || 'error');
        err.actStatus = parsed.actStatus;
        throw err;
      }
      return parsed.gift;
    };

    const emptyProgress = () => ({
      subscribed: false,
      shared: false,
      drawn: false,
      story: null,
      prize: null,
      email: '',
    });

    const readProgress = () => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return emptyProgress();
        const data = JSON.parse(raw);
        return {
          subscribed: Boolean(data && data.subscribed),
          shared: Boolean(data && data.shared),
          drawn: Boolean(data && data.drawn),
          story: data && data.story ? data.story : null,
          prize: data && data.prize ? data.prize : null,
          email: data && data.email ? String(data.email) : '',
        };
      } catch (err) {
        return emptyProgress();
      }
    };

    const writeProgress = (progress) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
      } catch (err) {}
    };

    const setSubscribeCopy = (wrap, done) => {
      if (!wrap) return;
      const before = wrap.querySelector('[data-state="before"]');
      const after = wrap.querySelector('[data-state="after"]');
      if (before) before.hidden = done;
      if (after) after.hidden = !done;
    };

    const setButtonState = (btn, mode, text) => {
      if (!btn) return;
      btn.classList.remove('is-locked', 'is-ready', 'is-done', 'is-open-share');
      btn.classList.add('is-' + mode);
      if (text) btn.textContent = text;

      if (mode === 'ready' || mode === 'open-share') {
        btn.removeAttribute('aria-disabled');
        btn.disabled = false;
      } else if (mode === 'done') {
        btn.setAttribute('aria-disabled', 'true');
        btn.disabled = true;
      } else {
        btn.setAttribute('aria-disabled', 'true');
        btn.disabled = true;
      }
    };

    const fillMemoryCard = (story) => {
      if (!memoryModal || !story) return;
      memoryModal.querySelectorAll('[data-memory-field]').forEach((el) => {
        const key = el.getAttribute('data-memory-field');
        const value = story[key];
        if (value) {
          el.textContent = value;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });

      const nextKey = Array.from(memoryModal.querySelectorAll('[data-memory-field]'))
        .map((el) => (el.hidden ? '' : el.textContent || ''))
        .join('\n');
      if (nextKey !== memoryBlobKey) {
        memoryBlobKey = nextKey;
        memoryBlobPromise = null;
        memoryBlobResolved = null;
      }
    };

    const PHOTO_MAX_BYTES = 4 * 1024 * 1024;
    const PHOTO_ALLOWED_TYPES = ['image/jpeg', 'image/png'];
    const PHOTO_ALLOWED_EXT = /\.(jpe?g|png)$/i;

    const isAllowedPhotoFile = (file) => {
      if (!file) return false;
      if (file.type) return PHOTO_ALLOWED_TYPES.includes(file.type);
      return PHOTO_ALLOWED_EXT.test(file.name || '');
    };

    const readFileAsDataUrl = (file) =>
      new Promise((resolve, reject) => {
        if (!file) {
          resolve('');
          return;
        }
        if (!isAllowedPhotoFile(file)) {
          reject(new Error('photo-invalid-type'));
          return;
        }
        if (file.size > PHOTO_MAX_BYTES) {
          reject(new Error('photo-too-large'));
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          resolve(String(reader.result || ''));
        };
        reader.onerror = () => {
          reject(reader.error || new Error('photo-read-failed'));
        };
        reader.readAsDataURL(file);
      });

    const collectStoryFromForm = () => {
      const formData = new FormData(shareForm);
      const story = {};

      formFields.forEach((field) => {
        const key = field.getAttribute('data-field-key');
        const type = field.getAttribute('data-field-type') || 'text';
        if (!key) return;

        if (type === 'file') {
          story[key] = pendingPhotos[key] || '';
          return;
        }

        story[key] = String(formData.get(key) || '').trim();
      });

      return story;
    };

    const assertApiOk = (payload, fallbackMessage) => {
      if (!payload || typeof payload !== 'object') {
        throw new Error(fallbackMessage || 'submit-failed');
      }
      const code = typeof payload.code === 'number' ? payload.code : null;
      if (code !== null && code !== 0) {
        throw new Error(payload.msg || payload.message || fallbackMessage || 'submit-failed');
      }
      return payload;
    };

    const getVerifyToken = async () => {
      const response = await fetch(API_CONFIG.baseUrl + '/api/v1/get-token', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Site': API_CONFIG.xSite,
          'Api-Key': API_CONFIG.apiKey,
        },
      });
      if (!response.ok) throw new Error('get-token-failed');
      const payload = assertApiOk(await response.json(), 'get-token-failed');
      const token = payload.data && payload.data.token ? String(payload.data.token) : '';
      const timestamp = payload.data && payload.data.timestamp != null
        ? String(payload.data.timestamp)
        : '';
      if (!token || !timestamp) throw new Error('get-token-invalid');
      return { token, timestamp };
    };

    const buildAuthHeaders = (auth) => ({
      Accept: 'application/json',
      'X-Site': API_CONFIG.xSite,
      'Api-Key': API_CONFIG.apiKey,
      'X-Verify-Token': auth.token,
      Timestamp: auth.timestamp,
    });

    const getSelectedPhotoFile = () => {
      if (pendingPhotoFiles.photo instanceof File) return pendingPhotoFiles.photo;
      const input = shareForm
        ? shareForm.querySelector('[data-share-photo-input][data-field-key="photo"]') ||
          shareForm.querySelector('[data-share-photo-input]')
        : null;
      return input && input.files && input.files[0] ? input.files[0] : null;
    };

    const uploadStoryPhoto = async (auth, file) => {
      const formData = new FormData();
      formData.append('dir', API_CONFIG.uploadDir);
      formData.append('file', file, file.name || 'photo.jpg');

      const response = await fetch(API_CONFIG.baseUrl + '/api/v1/upload/uploadImage', {
        method: 'POST',
        headers: buildAuthHeaders(auth),
        body: formData,
      });
      const payload = await response.json();
      assertApiOk(payload, 'upload-failed');
      const photoUrl = typeof payload.data === 'string' ? payload.data : '';
      if (!photoUrl) throw new Error('upload-invalid');
      return photoUrl;
    };

    const saveStoryData = async (auth, story, photoUrl) => {
      // multipart/form-data
      const formData = new FormData();
      formData.append('nickname', story.nickname || '');
      formData.append('city', story.city || '');
      formData.append('your_story', story.story || story.your_story || '');
      if (photoUrl) formData.append('photo', photoUrl);

      const response = await fetch(API_CONFIG.baseUrl + '/api/v1/brand-month/save-data', {
        method: 'POST',
        headers: buildAuthHeaders(auth),
        body: formData,
      });
      return assertApiOk(await response.json(), 'save-failed');
    };

    const submitStoryToApi = async (story) => {
      const auth = await getVerifyToken();
      const photoFile = getSelectedPhotoFile();
      let photoUrl = '';

       if (photoFile) {
        photoUrl = await uploadStoryPhoto(auth, photoFile);
      } 

      await saveStoryData(auth, story, photoUrl);
      return Object.assign({}, story, {
        photo: photoUrl || story.photo || '',
      });
    };

    const fillResultModal = (prize) => {
      if (!resultModal) return;
      const info = resultModal.querySelector('.modal-info');
      const titleEl = resultModal.querySelector('[data-result-title]');
      const descEl = resultModal.querySelector('[data-result-desc]');
      const prizeImage = resultModal.querySelector('[data-result-image]');

      const winTitleTpl = info ? info.getAttribute('data-result-win-title') || '' : '';
      const winDescTpl = info ? info.getAttribute('data-result-win-desc') || '' : '';
      const loseTitleTpl = info ? info.getAttribute('data-result-lose-title') || '' : '';
      const loseDescTpl = info ? info.getAttribute('data-result-lose-desc') || '' : '';

      const won = Boolean(prize && prize.isWin);
      const prizeLabel = prize && prize.name ? prize.name : '';
      const escapeHtml = (str) =>
        String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      const replacePrizeName = (text) =>
        String(text || '').replace(/\[Prize Name\]/gi, escapeHtml(prizeLabel));

      let title = '';
      let desc = '';
      if (prize) {
        title = prize.title
          ? replacePrizeName(prize.title)
          : replacePrizeName(won ? winTitleTpl : loseTitleTpl);
        desc = prize.desc
          ? replacePrizeName(prize.desc)
          : replacePrizeName(won ? winDescTpl : loseDescTpl);
      } else {
        title = loseTitleTpl;
        desc = loseDescTpl;
      }

      if (titleEl) {
        titleEl.innerHTML = title;
        titleEl.hidden = !title;
      }
      if (descEl) {
        descEl.innerHTML = desc;
        descEl.hidden = !desc;
        if (prize?.discountCode) {
          const codeEl = descEl.querySelector('.copy-code-text');
          if (codeEl) codeEl.textContent = String(prize.discountCode);
        }
      }

      resultModal.classList.toggle('is-win', won);
      resultModal.classList.toggle('is-lose', !won);

      const hasImage = Boolean(prize && prize.image);
      if (prizeImage) {
        if (hasImage) {
          prizeImage.src = prize.image;
          prizeImage.alt = prizeLabel || title || '';
          prizeImage.hidden = false;
        } else {
          prizeImage.removeAttribute('src');
          prizeImage.alt = '';
          prizeImage.hidden = true;
        }
      }
    };

    const pickPrize = () => {
      if (!gifts.length) return null;
      return gifts[Math.floor(Math.random() * gifts.length)];
    };

    // theme 里 angle = 该奖在转盘图上的中心角（12 点=0，顺时针）。停转：rotate(360 - angle)。
    const resolveWheelStopAngle = (prizeCenterAngle) => {
      const center = ((Number(prizeCenterAngle) || 0) % 360 + 360) % 360;
      return (360 - center) % 360;
    };

    const getWheelCurrentAngle = (el) => {
      if (!el) return 0;
      const matrix = window.getComputedStyle(el).transform;
      if (!matrix || matrix === 'none') return 0;
      const match = matrix.match(/matrix\(([^)]+)\)/);
      if (!match) return 0;
      const parts = match[1].split(',').map(Number);
      const deg = Math.round((Math.atan2(parts[1], parts[0]) * 180) / Math.PI);
      return ((deg % 360) + 360) % 360;
    };

    const setWheelAngleInstant = (sectorStartAngle) => {
      if (!wheel) return;
      const stopAt = resolveWheelStopAngle(sectorStartAngle);
      wheel.classList.remove('is-spinning');
      wheel.style.transition = 'none';
      wheel.style.transform = 'rotate(' + stopAt + 'deg)';
      void wheel.offsetWidth;
      wheel.style.transition = '';
    };

    const spinWheel = (targetAngle, onDone) => {
      if (!wheel || isSpinning) {
        if (typeof onDone === 'function') onDone();
        return;
      }

      const stopAt = resolveWheelStopAngle(targetAngle);
      const currentAngle = getWheelCurrentAngle(wheel);
      let delta = (stopAt - currentAngle + 360) % 360;
      if (delta === 0) delta = 360;
      const degrees = currentAngle + delta + 3 * 360;

      isSpinning = true;
      let finished = false;
      wheel.classList.add('is-spinning');
      wheel.style.transition = '';
      void wheel.offsetWidth;
      wheel.style.transform = 'rotate(' + degrees + 'deg)';

      const finish = () => {
        if (finished) return;
        finished = true;
        isSpinning = false;
        wheel.classList.remove('is-spinning');
        wheel.removeEventListener('transitionend', onEnd);
        if (typeof onDone === 'function') onDone();
      };

      const onEnd = (event) => {
        if (event.propertyName && event.propertyName !== 'transform') return;
        finish();
      };

      wheel.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, 4500);
    };

    const applyState = (progress) => {
      stepItems.forEach((item) => {
        const type = item.getAttribute('data-step-type');
        let active = false;
        if (type === 'subscribe') active = true;
        if (type === 'share') active = progress.shared;
        if (type === 'step') active = progress.shared;
        item.classList.toggle('is-active', active);
      });

      setSubscribeCopy(subscribeTitle, progress.subscribed);
      setSubscribeCopy(subscribeDesc, progress.subscribed);
      if (subscribeForm) subscribeForm.hidden = progress.subscribed;

      if (shareBtn) {
        if (progress.shared) {
          setButtonState(shareBtn, 'done', shareBtn.getAttribute('data-cta-done') || '');
        } else if (progress.subscribed) {
          setButtonState(shareBtn, 'ready', shareBtn.getAttribute('data-cta-ready') || '');
        } else {
          setButtonState(shareBtn, 'locked', shareBtn.getAttribute('data-cta-locked') || '');
        }
      }

      if (memoryBtn) {
        if (progress.shared) {
          setButtonState(memoryBtn, 'ready', memoryBtn.getAttribute('data-cta-ready') || '');
        } else if (progress.subscribed) {
          // Same entry as Share Now: open share form
          setButtonState(memoryBtn, 'open-share', memoryBtn.getAttribute('data-cta-locked') || '');
        } else {
          setButtonState(memoryBtn, 'locked', memoryBtn.getAttribute('data-cta-locked') || '');
        }
      }

      fillMemoryCard(progress.story);
      fillResultModal(progress.prize);

      // Already finished a draw: keep wheel on last prize after refresh
      if (progress.drawn && progress.prize) {
        setWheelAngleInstant(progress.prize.angle);
      }

      if (lotteryCard) {
        const wheelInteractive = progress.shared && !isSpinning;
        lotteryCard.classList.toggle('is-wheel-interactive', wheelInteractive);
        if (wheelInteractive) {
          lotteryCard.setAttribute('role', 'button');
          lotteryCard.setAttribute('tabindex', '0');
          lotteryCard.setAttribute(
            'aria-label',
            progress.drawn ? 'View your draw result' : 'Spin the wheel for your prize',
          );
        } else {
          lotteryCard.removeAttribute('role');
          lotteryCard.removeAttribute('tabindex');
          lotteryCard.removeAttribute('aria-label');
        }
      }

      if (progress.drawn || !progress.shared) {
        clearLotteryDrawError();
      }
    };

    const commitSharedStory = (story) => {
      progress = Object.assign({}, progress, {
        subscribed: true,
        shared: true,
        drawn: false,
        story: story,
        prize: null,
        email: progress.email || '',
      });
      writeProgress(progress);
      applyState(progress);
      shareModal?.hide();
    };

    const runDrawAndSpin = (opener, prize) => {
      const resolvedPrize = prize || pickPrize();
      progress = Object.assign({}, progress, { prize: resolvedPrize });
      writeProgress(progress);
      clearLotteryDrawError();

      spinWheel(resolvedPrize && resolvedPrize.angle != null ? resolvedPrize.angle : 0, () => {
        progress = Object.assign({}, progress, { drawn: true });
        writeProgress(progress);
        applyState(progress);
        fillResultModal(progress.prize);
        resultModal?.show(opener || shareBtn || memoryBtn);
      });
    };

    const startShareSuccessFlow = (story, opener, prize) => {
      commitSharedStory(story);
      runDrawAndSpin(opener, prize);
    };

    let progress = readProgress();
    applyState(progress);

    root.querySelectorAll('.anniversary-lottery-terms').forEach((el) => {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('aria-haspopup')) el.setAttribute('aria-haspopup', 'dialog');
    });

    const zoomModal = document.getElementById('PopupModal-anniversary-wheel-zoom');
    const zoomImage = zoomModal ? zoomModal.querySelector('[data-lottery-zoom-image]') : null;

    if (wheel && zoomModal && zoomImage && typeof zoomModal.show === 'function') {
      wheel.addEventListener('click', (event) => {
        if (lotteryCard && lotteryCard.classList.contains('is-wheel-interactive')) return;
        if (wheel.classList.contains('is-spinning')) return;
        const src = lotteryCard ? lotteryCard.getAttribute('data-zoom-src') || '' : '';
        if (!src) return;
        event.preventDefault();
        event.stopPropagation();
        zoomImage.src = src;
        zoomImage.alt = (lotteryCard && lotteryCard.getAttribute('data-zoom-alt')) || 'Prize wheel';
        zoomModal.show(wheel);
      });
    }

    if (lotteryCard) {
      lotteryCard.addEventListener('click', (event) => {
        if (!lotteryCard.classList.contains('is-wheel-interactive')) return;
        event.preventDefault();
        handleLotteryWheelActivate(lotteryCard);
      });
      lotteryCard.addEventListener('keydown', (event) => {
        if (!lotteryCard.classList.contains('is-wheel-interactive')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        handleLotteryWheelActivate(lotteryCard);
      });
    }

    root.addEventListener('click', (event) => {
      const termsTrigger = event.target.closest('.anniversary-lottery-terms');
      if (!termsTrigger || !root.contains(termsTrigger)) return;
      event.preventDefault();
      if (!termsModal || typeof termsModal.show !== 'function') return;
      termsModal.show(termsTrigger);
    });

    root.addEventListener('keydown', (event) => {
      const termsTrigger = event.target.closest('.anniversary-lottery-terms');
      if (!termsTrigger || !root.contains(termsTrigger)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      if (!termsModal || typeof termsModal.show !== 'function') return;
      termsModal.show(termsTrigger);
    });

    const pushAnniversarySubscribe = (status, email) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'subscribe',
        event_parameters: {
          module: '15th_anniversary_subscription',
          status,
          email: email || '',
        },
      });
    };

    window.addEventListener('klaviyoForms', (event) => {
      const detail = event.detail || {};
      if (detail.type !== 'submit' && detail.type !== 'stepSubmit') return;
      if (formId && detail.formId && String(detail.formId) !== String(formId)) return;
      if (detail.type === 'submit') {
        const meta = detail.metaData || {};
        pushAnniversarySubscribe(
          'success',
          String(meta.$email || meta.email || '').trim(),
        );
      }
      const meta = detail.metaData || {};
      const email = String(meta.$email || meta.email || '').trim();
      progress = Object.assign({}, progress, {
        subscribed: true,
        email: email || progress.email || '',
      });
      writeProgress(progress);
      applyState(progress);
    });

    if (shareBtn) {
      shareBtn.addEventListener('click', () => {
        if (shareBtn.dataset.selectContentSent === '1') return;
        shareBtn.dataset.selectContentSent = '1';
        window.setTimeout(() => {
          delete shareBtn.dataset.selectContentSent;
        }, 300);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'select_content',
          event_parameters: {
            content_type: 'subscribe_draw',
            content_name: 'unlock_draw',
            button_name: (shareBtn.textContent || '').trim(),
          },
        });
        if (!progress.subscribed || progress.shared || isSpinning) return;
        shareModal?.show(shareBtn);
      });
    }

    const openMemoryOrShare = (opener) => {
      if (!progress.subscribed || isSpinning) return;
      if (!progress.shared) {
        shareModal?.show(opener);
        return;
      }
      fillMemoryCard(progress.story);
      memoryModal?.show(opener);
      warmMemoryShare();
    };

    if (memoryBtn) {
      memoryBtn.addEventListener('click', () => {
        openMemoryOrShare(memoryBtn);
      });
    }

    const copyPlainText = async (text) => {
      if (!text) return false;
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (_error) {
          // fall through
        }
      }
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const ok = document.execCommand('copy');
        textarea.remove();
        return ok;
      } catch (_error) {
        return false;
      }
    };

    const COPY_CODE_SUCCESS_ICON =
      '<svg class="copy-code-btn-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 1C6.61553 1 5.26216 1.41054 4.11101 2.17971C2.95987 2.94888 2.06266 4.04213 1.53285 5.32122C1.00303 6.6003 0.86441 8.00776 1.13451 9.36563C1.4046 10.7235 2.07129 11.9708 3.05026 12.9497C4.02922 13.9287 5.2765 14.5954 6.63437 14.8655C7.99224 15.1356 9.3997 14.997 10.6788 14.4672C11.9579 13.9373 13.0511 13.0401 13.8203 11.889C14.5895 10.7378 15 9.38447 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1ZM7 10.7954L4.5 8.2954L5.2953 7.5L7 9.2046L10.705 5.5L11.5029 6.29295L7 10.7954Z" fill="currentColor"/></svg>';

    if (resultModal) {
      const resultModalInfo = resultModal.querySelector('.modal-info');
      const couponCopySuccess =
        resultModalInfo?.getAttribute('data-coupon-copy-success') || 'Copied';

      resultModal.addEventListener('click', async (event) => {
        const copyBtn = event.target.closest('.copy-code-btn');
        if (copyBtn && resultModal.contains(copyBtn)) {
          event.preventDefault();
          const code = (
            copyBtn.closest('.copy-code-container')?.querySelector('.copy-code-text')?.textContent || ''
          ).trim();
          if (!code) return;
          const copied = await copyPlainText(code);
          if (!copied) return;
          const label = copyBtn.querySelector('.copy-code-btn-label');
          if (label) {
            const original = label.textContent || '';
            if (!copyBtn.querySelector('.copy-code-btn-icon')) {
              label.insertAdjacentHTML('beforebegin', COPY_CODE_SUCCESS_ICON);
            }
            label.textContent = couponCopySuccess;
            window.setTimeout(() => {
              copyBtn.querySelector('.copy-code-btn-icon')?.remove();
              label.textContent = original;
            }, 2000);
          }
          return;
        }

        const jumpBtn = event.target.closest('.jump-to-open-moment');
        if (!jumpBtn || !resultModal.contains(jumpBtn)) return;
        event.preventDefault();
        if (typeof resultModal.hide === 'function') resultModal.hide();
        openMemoryOrShare(jumpBtn);
      });
    }

    const memoryShareBtn = memoryModal
      ? memoryModal.querySelector('[data-memory-share]')
      : null;
    const memoryShareStatus = memoryModal
      ? memoryModal.querySelector('[data-memory-share-status]')
      : null;
    let html2canvasLoader = null;
    let memoryShareBusy = false;
    let memoryShareStatusTimer = null;
    /** Set on pointerdown (user activation); share sheet ends activation on Win */
    let desktopShareLinkCopied = false;
    let desktopShareLinkCopyPromise = null;
    const MEMORY_SHARE_TOAST_MS = 3200;

    const HTML2CANVAS_CDN =
      'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';

    const loadHtml2Canvas = () => {
      if (window.html2canvas) return Promise.resolve(window.html2canvas);
      if (html2canvasLoader) return html2canvasLoader;
      html2canvasLoader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = HTML2CANVAS_CDN;
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.onload = () => {
          if (window.html2canvas) resolve(window.html2canvas);
          else reject(new Error('html2canvas-missing'));
        };
        script.onerror = () => reject(new Error('html2canvas-load-failed'));
        document.head.appendChild(script);
      });
      return html2canvasLoader;
    };

    const canvasToBlob = (canvas) =>
      new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject(new Error('canvas-to-blob-failed'));
          },
          'image/png',
          1
        );
      });

    const captureMemoryCardBlob = async () => {
      if (!memoryModal) throw new Error('memory-modal-missing');
      const target = memoryModal.querySelector('.modal-info');
      if (!target) throw new Error('memory-card-missing');

      // Ensure latest story text is painted before capture
      if (progress && progress.story) fillMemoryCard(progress.story);

      if (document.fonts?.ready) {
        try {
          await Promise.race([
            document.fonts.ready,
            new Promise((resolve) => {
              window.setTimeout(resolve, 350);
            }),
          ]);
        } catch (_error) {
          // ignore font readiness errors
        }
      }

      const html2canvas = await loadHtml2Canvas();
      memoryModal.classList.add('is-memory-capturing');

      const bodyEl = target.querySelector('.modal-info-body');
      const prevTargetOverflow = target.style.overflow;
      const prevBodyOverflow = bodyEl ? bodyEl.style.overflow : '';
      const prevBodyPosition = bodyEl ? bodyEl.style.position : '';
      const prevBodyZ = bodyEl ? bodyEl.style.zIndex : '';

      target.style.overflow = 'visible';
      if (bodyEl) {
        bodyEl.style.overflow = 'visible';
        bodyEl.style.position = 'relative';
        bodyEl.style.zIndex = '2';
      }

      const copyTextPaintStyles = (sourceRoot, cloneRoot) => {
        const selector =
          '.anniversary-lottery-modal-title, .anniversary-lottery-modal-desc, .anniversary-lottery-memory-field, .anniversary-lottery-memory-meta, .anniversary-lottery-memory-body, .modal-info-body';
        const sourceNodes = [sourceRoot, ...sourceRoot.querySelectorAll(selector)];
        const cloneNodes = [cloneRoot, ...cloneRoot.querySelectorAll(selector)];
        sourceNodes.forEach((sourceNode, index) => {
          const cloneNode = cloneNodes[index];
          if (!sourceNode || !cloneNode) return;
          const cs = window.getComputedStyle(sourceNode);
          cloneNode.style.fontFamily = cs.fontFamily;
          cloneNode.style.fontSize = cs.fontSize;
          cloneNode.style.fontWeight = cs.fontWeight;
          cloneNode.style.fontStyle = cs.fontStyle;
          cloneNode.style.lineHeight = cs.lineHeight;
          cloneNode.style.letterSpacing = cs.letterSpacing;
          cloneNode.style.textAlign = cs.textAlign;
          cloneNode.style.whiteSpace = cs.whiteSpace;
          cloneNode.style.color = cs.color;
          cloneNode.style.webkitTextFillColor = cs.color;
          cloneNode.style.opacity = cs.opacity;
          cloneNode.style.visibility = cs.visibility;
          cloneNode.style.display = cs.display;
          cloneNode.style.transform = 'none';
        });

        cloneRoot.querySelectorAll('.anniversary-lottery-memory-field[data-field-role="body"]').forEach((el) => {
          const text = (el.textContent || '').trim();
          if (!text) return;
          if (text.startsWith('\u201C') || text.startsWith('"')) return;
          el.textContent = `\u201C${text}\u201D`;
        });

        const cloneBody = cloneRoot.querySelector('.modal-info-body');
        if (cloneBody) {
          cloneBody.style.position = 'relative';
          cloneBody.style.zIndex = '2';
          cloneBody.style.overflow = 'visible';
        }
        cloneRoot.style.overflow = 'visible';
        [cloneRoot, ...cloneRoot.querySelectorAll('*')].forEach((el) => {
          el.style.setProperty('border-radius', '0', 'important');
        });
      };

      const squareNodes = [target, ...target.querySelectorAll('*')];
      const previousRadius = squareNodes.map((el) => el.style.getPropertyValue('border-radius'));
      squareNodes.forEach((el) => {
        el.style.setProperty('border-radius', '0', 'important');
      });

      try {
        const canvas = await html2canvas(target, {
          backgroundColor: '#ff5a1f',
          useCORS: true,
          allowTaint: false,
          imageTimeout: 3000,
          scale: 2,
          logging: false,
          foreignObjectRendering: false,
          ignoreElements: (el) =>
            Boolean(
              el &&
                (el.hasAttribute('data-html2canvas-ignore') ||
                  el.classList?.contains('anniversary-lottery-modal-close'))
            ),
          onclone: (_clonedDoc, clonedEl) => {
            copyTextPaintStyles(target, clonedEl);
          },
        });
        return canvasToBlob(canvas);
      } finally {
        squareNodes.forEach((el, index) => {
          const previous = previousRadius[index];
          if (previous) el.style.setProperty('border-radius', previous);
          else el.style.removeProperty('border-radius');
        });
        target.style.overflow = prevTargetOverflow;
        if (bodyEl) {
          bodyEl.style.overflow = prevBodyOverflow;
          bodyEl.style.position = prevBodyPosition;
          bodyEl.style.zIndex = prevBodyZ;
        }
        memoryModal.classList.remove('is-memory-capturing');
      }
    };

    const isMobileShareDevice = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '');

    const ensureMemoryBlob = () => {
      if (memoryBlobResolved) return Promise.resolve(memoryBlobResolved);
      if (memoryBlobPromise) return memoryBlobPromise;
      const keyAtStart = memoryBlobKey;
      const pending = captureMemoryCardBlob()
        .then((blob) => {
          if (memoryBlobKey !== keyAtStart) {
            memoryBlobPromise = null;
            memoryBlobResolved = null;
            return ensureMemoryBlob();
          }
          memoryBlobResolved = blob;
          return blob;
        })
        .catch((error) => {
          if (memoryBlobKey === keyAtStart) {
            memoryBlobPromise = null;
            memoryBlobResolved = null;
          }
          throw error;
        });
      memoryBlobPromise = pending;
      return pending;
    };

    const warmMemoryShare = () => {
      loadHtml2Canvas().catch(() => {});
      if (progress?.story) fillMemoryCard(progress.story);
    };

    const downloadBlobFile = (blob, filename) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 2000);
    };

    const getInstagramStoryDeepLink = () => {
      const ua = navigator.userAgent || '';
      if (/Android/i.test(ua)) {
        return 'intent://story-camera/#Intent;scheme=instagram;package=com.instagram.android;S.browser_fallback_url=https%3A%2F%2Fwww.instagram.com%2F;end';
      }
      return 'instagram://story-camera';
    };

    const supportsImageFileShare = () => {
      try {
        if (!navigator.share || typeof navigator.canShare !== 'function') return false;
        const probe = new File(['share'], 'share.png', { type: 'image/png' });
        return navigator.canShare({ files: [probe] });
      } catch (_error) {
        return false;
      }
    };

    const INSTAGRAM_SHARE_URL = 'https://www.instagram.com/';

    // Open about:blank under the click gesture, then navigate to IG after async work
    const createInstagramLauncher = () => {
      const ua = navigator.userAgent || '';
      const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
      const deepLink = getInstagramStoryDeepLink();
      let win = null;

      try {
        win = window.open(isMobile ? 'about:blank' : INSTAGRAM_SHARE_URL, '_blank');
      } catch (_error) {
        win = null;
      }

      return {
        open: () => {
          if (!isMobile) {
            if (!win || win.closed) {
              window.open(INSTAGRAM_SHARE_URL, '_blank', 'noopener,noreferrer');
            }
            return;
          }

          if (win && !win.closed) {
            try {
              win.location.href = deepLink;
              return;
            } catch (_error) {
              // fall through
            }
          }

          const iframe = document.createElement('iframe');
          iframe.setAttribute('aria-hidden', 'true');
          iframe.style.cssText =
            'position:fixed;width:0;height:0;border:0;opacity:0;pointer-events:none;';
          iframe.src = deepLink;
          document.body.appendChild(iframe);
          window.setTimeout(() => iframe.remove(), 2500);

          try {
            window.location.href = deepLink;
          } catch (_error) {
            window.open(INSTAGRAM_SHARE_URL, '_blank', 'noopener,noreferrer');
          }
        },
        cancel: () => {
          if (win && !win.closed) {
            try {
              win.close();
            } catch (_error) {
              // ignore
            }
          }
        },
      };
    };

    const openSystemShare = async (data) => {
      if (typeof navigator.share !== 'function') return 'unsupported';
      try {
        await navigator.share(data);
        return 'shared';
      } catch (error) {
        if (error && error.name === 'AbortError') return 'aborted';
        return 'failed';
      }
    };

    const getMemoryShareMeta = () => {
      let url = memoryModal?.getAttribute('data-memory-share-url') || '';
      url = url.trim();
      if (url && !/^https?:\/\//i.test(url)) {
        try {
          url = new URL(url, window.location.origin).href;
        } catch (_error) {
          url = window.location.href;
        }
      }
      if (!url) url = window.location.href;
      const prefix = (memoryModal?.getAttribute('data-memory-share-text') || '').trim();
      const text = prefix ? `${prefix} ${url}` : url;
      return { url, text };
    };

    const hideMemoryShareToast = () => {
      if (!memoryShareStatus) return;
      memoryShareStatus.classList.remove('is-visible', 'is-error');
      memoryShareStatus.textContent = '';
      memoryShareStatus.hidden = true;
    };

    const shouldShowDesktopShareToast = () => !isMobileShareDevice();

    const announceMemoryShareStatus = (message, { isError = false } = {}) => {
      if (!shouldShowDesktopShareToast() || !memoryShareStatus || !message) return;
      if (memoryShareStatusTimer) {
        window.clearTimeout(memoryShareStatusTimer);
        memoryShareStatusTimer = null;
      }
      memoryShareStatus.classList.toggle('is-error', Boolean(isError));
      memoryShareStatus.hidden = false;
      memoryShareStatus.textContent = message;
      memoryShareStatus.classList.remove('is-visible');
      window.requestAnimationFrame(() => {
        memoryShareStatus.classList.add('is-visible');
      });
      memoryShareStatusTimer = window.setTimeout(() => {
        hideMemoryShareToast();
        memoryShareStatusTimer = null;
      }, MEMORY_SHARE_TOAST_MS);
    };

    const copyMemoryShareText = async () => {
      const { text } = getMemoryShareMeta();
      if (!text) return false;
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (_error) {
          // fall through to execCommand while user activation may still apply
        }
      }
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const ok = document.execCommand('copy');
        textarea.remove();
        return ok;
      } catch (_error) {
        return false;
      }
    };

    const MEMORY_BLOB_WAIT_MS = 8000;

    const buildSharePayloads = (file, meta) => {
      const withLink = {
        files: [file],
        title: 'Shokz Open Moment',
        text: meta.text,
        url: meta.url,
      };
      const withTextOnly = { files: [file], text: meta.text };
      const filesOnly = { files: [file] };
      const candidates = [withLink, withTextOnly, filesOnly];
      if (typeof navigator.canShare !== 'function') return candidates;
      return candidates.filter((payload) => {
        try {
          return navigator.canShare(payload);
        } catch (_error) {
          return false;
        }
      });
    };

    const waitForMemoryBlob = () =>
      Promise.race([
        ensureMemoryBlob(),
        new Promise((_resolve, reject) => {
          window.setTimeout(() => reject(new Error('memory-blob-timeout')), MEMORY_BLOB_WAIT_MS);
        }),
      ]);

    const trySystemShareWithPayloads = async (payloads) => {
      if (typeof navigator.share !== 'function') return { status: 'unsupported' };
      if (!payloads.length) return { status: 'unsupported' };
      for (const shareData of payloads) {
        const result = await openSystemShare(shareData);
        if (result === 'shared') return { status: 'shared', payload: shareData };
        if (result === 'aborted') return { status: 'aborted' };
      }
      return { status: 'failed' };
    };

    const announceShareLinkCopied = () => {
      announceMemoryShareStatus(
        'Link copied. Paste it in your caption when you share the image.',
      );
    };

    const ensureDesktopShareLinkCopied = async () => {
      if (!shouldShowDesktopShareToast()) return false;
      if (desktopShareLinkCopied) return true;
      if (desktopShareLinkCopyPromise) {
        desktopShareLinkCopied = await desktopShareLinkCopyPromise;
        desktopShareLinkCopyPromise = null;
        return desktopShareLinkCopied;
      }
      desktopShareLinkCopied = await copyMemoryShareText();
      return desktopShareLinkCopied;
    };

    const showDesktopLinkCopiedToastIfReady = async () => {
      const copied = await ensureDesktopShareLinkCopied();
      if (copied) announceShareLinkCopied();
      return copied;
    };

    /** 桌面：无法系统分享时的兜底（链接已在 pointerdown 复制，此处 Toast + IG + 下载） */
    const runMemoryShareFallback = async (blob) => {
      await showDesktopLinkCopiedToastIfReady();
      createInstagramLauncher().open();
      downloadBlobFile(blob, 'shokz-open-moment.png');
    };

    const shareMemoryToInstagram = async () => {
      if (memoryShareBusy) return;
      memoryShareBusy = true;
      if (memoryShareBtn) memoryShareBtn.setAttribute('aria-busy', 'true');

      const canSystemShare = supportsImageFileShare();
      const shareMeta = getMemoryShareMeta();

      try {
        await ensureDesktopShareLinkCopied();

        const blob = await waitForMemoryBlob();
        const file = new File([blob], 'shokz-open-moment.png', { type: 'image/png' });

        if (canSystemShare) {
          const payloads = buildSharePayloads(file, shareMeta);
          const fileResult = await trySystemShareWithPayloads(payloads);
          if (fileResult.status === 'shared') {
            await showDesktopLinkCopiedToastIfReady();
            return;
          }
          if (fileResult.status === 'aborted') return;
          await runMemoryShareFallback(blob);
          return;
        }

        await runMemoryShareFallback(blob);
      } catch (error) {
        console.warn('Memory Instagram share failed', error);
        if (error && error.message === 'memory-blob-timeout') {
          announceMemoryShareStatus('Could not prepare the image in time. Please try again.', {
            isError: true,
          });
        }
      } finally {
        memoryShareBusy = false;
        desktopShareLinkCopied = false;
        desktopShareLinkCopyPromise = null;
        if (memoryShareBtn) memoryShareBtn.removeAttribute('aria-busy');
      }
    };

    if (memoryShareBtn) {
      memoryShareBtn.addEventListener('pointerdown', () => {
        warmMemoryShare();
        if (!shouldShowDesktopShareToast()) return;
        desktopShareLinkCopied = false;
        desktopShareLinkCopyPromise = copyMemoryShareText().then((ok) => {
          desktopShareLinkCopied = ok;
          return ok;
        });
      });
      memoryShareBtn.addEventListener('click', (event) => {
        event.preventDefault();
        shareMemoryToInstagram();
      });
    }

    if (progress.shared) {
      warmMemoryShare();
    }

    if (shareForm) {
      const agreeInput = shareForm.querySelector('[data-share-form-agree]');
      const syncFormAgreementValidity = () => {
        if (!agreeInput) return;
        if (!agreeInput.checked) {
          agreeInput.setCustomValidity(shareFormMessages.shareFormAgreeError || '');
        } else {
          agreeInput.setCustomValidity('');
        }
      };

      shareForm.querySelectorAll('[data-share-photo-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const key = trigger.getAttribute('data-field-key') || 'photo';
          const input = shareForm.querySelector(
            '[data-share-photo-input][data-field-key="' + key + '"]'
          );
          if (input) input.click();
        });
      });

      if (agreeInput) {
        agreeInput.addEventListener('change', () => {
          syncFormAgreementValidity();
        });
        const agreeLabel = shareForm.querySelector('label[for="' + agreeInput.id + '"]');
        if (agreeLabel) {
          agreeLabel.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', (event) => {
              event.stopPropagation();
            });
          });
        }
      }

      shareForm.querySelectorAll('[data-share-photo-input]').forEach((input) => {
        const clearPhotoPreview = (key, preview, trigger) => {
          pendingPhotos[key] = '';
          delete pendingPhotoFiles[key];
          if (preview) {
            preview.hidden = true;
            preview.removeAttribute('src');
            preview.alt = '';
          }
          if (trigger) {
            trigger.classList.remove('is-filled');
            trigger.setAttribute('aria-label', trigger.getAttribute('data-upload-label') || 'Upload Files');
          }
        };

        input.addEventListener('change', () => {
          const key = input.getAttribute('data-field-key') || input.getAttribute('name') || 'photo';
          const preview = shareForm.querySelector(
            '[data-share-photo-preview][data-field-key="' + key + '"]'
          );
          const trigger = shareForm.querySelector(
            '[data-share-photo-trigger][data-field-key="' + key + '"]'
          );
          const file = input.files && input.files[0] ? input.files[0] : null;

          if (!file) {
            clearPhotoPreview(key, preview, trigger);
            return;
          }

          pendingPhotoFiles[key] = file;
          readFileAsDataUrl(file)
            .then((dataUrl) => {
              pendingPhotos[key] = dataUrl;
              if (preview) {
                preview.src = dataUrl;
                preview.alt = file.name || 'Uploaded photo';
                preview.hidden = !dataUrl;
              }
              if (trigger) {
                trigger.classList.add('is-filled');
                trigger.setAttribute('aria-label', 'Replace uploaded photo');
              }
            })
            .catch(() => {
              input.value = '';
              clearPhotoPreview(key, preview, trigger);
              if (shareFormError) {
                shareFormError.hidden = false;
                shareFormError.textContent = shareFormMessages.shareFormPhotoError || '';
              }
            });
        });
      });

      shareForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!progress.subscribed || progress.shared || isSpinning) return;

        syncFormAgreementValidity();

        if (!shareForm.checkValidity()) {
          shareForm.reportValidity();
          return;
        }

        if (shareFormError) {
          shareFormError.hidden = true;
          shareFormError.textContent = '';
        }

        const story = collectStoryFromForm();
        const opener = shareModal.openedBy || shareBtn || memoryBtn;
        const submitBtn = shareForm.querySelector('.anniversary-lottery-submit');

        let storySaved = false;
        try {
          if (submitBtn) submitBtn.disabled = true;
          const savedStory = await submitStoryToApi(story);
          storySaved = true;
          commitSharedStory(savedStory);

          try {
            const prize = await resolveDrawPrize();
            runDrawAndSpin(opener, prize);
          } catch (lotteryErr) {
            reportLotteryDrawFailure(lotteryErr);
          }
        } catch (err) {
          if (shareFormError) {
            shareFormError.hidden = false;
            shareFormError.textContent = shareFormMessages.submitFailed;
          }
        } finally {
          if (submitBtn && !storySaved) submitBtn.disabled = false;
        }
      });
    }

    observeModuleImpression('#anniversary-lottery', { module: 'subscribe_draw' });
  };

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('anniversary-lottery');
    if (!root) return;
    initAnniversaryLottery(root);
  });
})();
